import Vue from 'vue'
import Vuex from 'vuex'
import {RootState} from './store-types'
import {user} from './modules/user'
import {subject} from './modules/subject'
import {classModule} from './modules/class'
import {userCollection} from './modules/user-collection'
import {classCollection} from './modules/class-collection'
import {subjectCollection} from './modules/subject-collection'
import {internshipCollection} from './modules/internship-collection'

Vue.use(Vuex)

const state: RootState = {}

const store = new Vuex.Store({
    state,
    modules: {
        user,
        subject,
        classModule,
        userCollection,
        classCollection,
        subjectCollection,
        internshipCollection,
    }
})

export default store

export function useStore() {
    return store
}
